import { Box, Button, Container, Heading, Text, Stack } from '@chakra-ui/react';
import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router';

export function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = 'Something went wrong';
  let message = 'An unexpected error occurred.';

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = 'Page not found';
      message = "The page you're looking for doesn't exist.";
    } else {
      title = `Error ${error.status}`;
      message = error.statusText;
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <Container maxW="container.md" py={16}>
      <Stack gap={6} textAlign="center">
        <Box>
          <Heading size="xl" mb={2}>
            {title}
          </Heading>
          <Text color="gray.600">{message}</Text>
        </Box>
        <Button onClick={() => navigate('/')} colorScheme="green">
          Go Home
        </Button>
      </Stack>
    </Container>
  );
}
